import { PatternFormat } from "react-number-format";

function PhoneText({ text, ...rest }: any) {
  return (
    <PatternFormat
      displayType="text"
      format="+1 (###) ###-####"
      value={text}
      valueIsNumericString
      {...rest}
    />
  );
}

export default PhoneText;
